const principalRoutes = [
  "dashboard",
  "branches",
  "staffs",
  "students",
  "broadcast",
  "schooldata",
  "profile",
  "logout",
  "audit-logs",
  "departments",
];

const adminRoutes = [
  "dashboard",
  "staffs",
  "broadcast",
  "notifications",
  "logout",
  "students",
  "register",
  "sign-up",
  "result",
  "generate",
  "schedules",
  "examNotifications",
  "live-examination",
  "video-conference",
  "events",
  "schoolPlans",
  "attendance",
  "profile",
  "analytics",
  "download-certificate",
  "report",
  "poll-management",
  "leaveFormat",
  "parentfeedback",
  "schooldata",
  "service",
  "finance",
  "staffmanagment",
  "procurement",
  "transport",
  "staff-library",
  "audit-logs",
  "departments",
];
const registrarRoutes = [
  "attendance",
  "result",
  "broadcast",
  "staffs",
  "students",
  "classes",
  "subjects",
  "examtypes",
  "live-examination",
  "profile",
  "schedules",
  "logout",
  "library",
  "schoolPlans",
  "examNotifications",
  "download-certificate",
  "report",
  "poll-management",
  "leaveFormat",
  "parentfeedback",
  "schooldata",
  "register",
  "service",
  "procurement",
  "transport",
];
const teacherRoutes = [
  "home",
  "broadcast",
  "students",
  "attendance",
  "result",
  "tasks",
  "live-examination",
  "video-conference",
  "result-tracking",
  "notifications",
  "requests",
  "events",
  "examNotifications",
  "question",
  "poll-management",
  "fileshare",
  "purchase",
  "profile",
  "logout",
  "analytics",
  "procurement",
  "generate",
  "communication-book",
];

const directorRoutes = [
  "dashboard",
  "students",
  "broadcast",
  "attendance",
  "result",
  "schedules",
  "classes",
  "subjects",
  "examtypes",
  "examNotifications",
  "live-examination",
  "video-conference",
  "analytics",
  "parentfeedback",
  "poll-management",
  "result",
  "profile",
  "logout",
];

const financeRoutes = [
  "dashboard",
  "service",
  "finance",
  "procurement",
  "transport",
  "profile",
  "logout",
];

const hrRoutes = ["dashboard", "staffs", "staffmanagment", "profile", "logout"];

const supervisorRoutes = [
  "dashboard",
  "staffs",
  "broadcast",
  "staffmanagment",
  "schedules",
  "notifications",
  "profile",
  "logout",
];

const librarianRoutes = ["library", "profile", "logout"];

export const Role_Route = (role) => {
  if (!role) return [];

  const normalizedRole = role.toLowerCase();

  if (normalizedRole === "principal") return principalRoutes;
  if (normalizedRole === "admin") return adminRoutes;
  if (normalizedRole === "registrar" || normalizedRole === "encoder") return registrarRoutes;
  if (normalizedRole === "teacher") return teacherRoutes;
  if (normalizedRole === "director" || normalizedRole === "headTeacher") return directorRoutes;
  if (normalizedRole === "finance") return financeRoutes;
  if (normalizedRole === "hr") return hrRoutes;
  if (normalizedRole === "supervisor") return supervisorRoutes;
  if (normalizedRole === "librarian") return librarianRoutes;

  return [];
};

export const Role_Route_init = (role) => {
  if (!role) return "login";

  const normalizedRole = role.toLowerCase();

  if (normalizedRole === "principal") return "dashboard";
  if (normalizedRole === "admin") return "dashboard";
  if (normalizedRole === "registrar" || normalizedRole === "encoder") return "attendance";
  if (normalizedRole === "teacher") return "home";
  if (normalizedRole === "director" || normalizedRole === "headTeacher") return "dashboard";
  if (normalizedRole === "finance") return "dashboard";
  if (normalizedRole === "hr") return "dashboard";
  if (normalizedRole === "supervisor") return "dashboard";
  if (normalizedRole === "librarian") return "dashboard";

  return "login";
};
